/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
import type { CopyPricePreviewItem } from './CopyPricePreviewItem';
import {
    CopyPricePreviewItemFromJSON,
    CopyPricePreviewItemFromJSONTyped,
    CopyPricePreviewItemToJSON,
    CopyPricePreviewItemToJSONTyped,
} from './CopyPricePreviewItem';

/**
 * 
 * @export
 * @interface CopyPricePreviewResponse
 */
export interface CopyPricePreviewResponse {
    /**
     * 
     * @type {number}
     * @memberof CopyPricePreviewResponse
     */
    sourcePricelistId: number;
    /**
     * 
     * @type {number}
     * @memberof CopyPricePreviewResponse
     */
    totalCount: number;
    /**
     * 
     * @type {number}
     * @memberof CopyPricePreviewResponse
     */
    wouldCopyCount: number;
    /**
     * 
     * @type {number}
     * @memberof CopyPricePreviewResponse
     */
    wouldSkipCount: number;
    /**
     * 
     * @type {Array<CopyPricePreviewItem>}
     * @memberof CopyPricePreviewResponse
     */
    items: Array<CopyPricePreviewItem>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CopyPricePreviewResponse
     */
    errors: Array<string>;
}

/**
 * Check if a given object implements the CopyPricePreviewResponse interface.
 */
export function instanceOfCopyPricePreviewResponse(value: object): value is CopyPricePreviewResponse {
    if (!('sourcePricelistId' in value) || value['sourcePricelistId'] === undefined) return false;
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    if (!('wouldCopyCount' in value) || value['wouldCopyCount'] === undefined) return false;
    if (!('wouldSkipCount' in value) || value['wouldSkipCount'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('errors' in value) || value['errors'] === undefined) return false;
    return true;
}

export function CopyPricePreviewResponseFromJSON(json: any): CopyPricePreviewResponse {
    return CopyPricePreviewResponseFromJSONTyped(json, false);
}

export function CopyPricePreviewResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CopyPricePreviewResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'sourcePricelistId': json['sourcePricelistId'],
        'totalCount': json['totalCount'],
        'wouldCopyCount': json['wouldCopyCount'],
        'wouldSkipCount': json['wouldSkipCount'],
        'items': ((json['items'] as Array<any>).map(CopyPricePreviewItemFromJSON)),
        'errors': json['errors'],
    };
}

export function CopyPricePreviewResponseToJSON(json: any): CopyPricePreviewResponse {
    return CopyPricePreviewResponseToJSONTyped(json, false);
}

export function CopyPricePreviewResponseToJSONTyped(value?: CopyPricePreviewResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sourcePricelistId': value['sourcePricelistId'],
        'totalCount': value['totalCount'],
        'wouldCopyCount': value['wouldCopyCount'],
        'wouldSkipCount': value['wouldSkipCount'],
        'items': ((value['items'] as Array<any>).map(CopyPricePreviewItemToJSON)),
        'errors': value['errors'],
    };
}

